import { redirect } from "react-router"
import { SESSION_STATUS_ENUM } from "@antipartido-inc/contracts-ifaces"
import { useUserInfoStore, useKycStatusStore } from "../../state"

const ALLOWED_KYC_STATUSES = [SESSION_STATUS_ENUM.APPROVED, SESSION_STATUS_ENUM.IN_REVIEW]

export const loader = async () => {
  const kycStatus = await useKycStatusStore.getState().updateKycStatus()

  if (kycStatus && ALLOWED_KYC_STATUSES.includes(kycStatus.status)) {
    const userInfo = await useUserInfoStore.getState().getOrFetch()

    if (userInfo?.wallet) {
      return redirect("/dashboard")
    }

    return redirect("/create-wallet")
  }

  return null
}
